import { Breakpoint } from '@/enums'
import { ClearIcon } from '@/icons'
import { useIsMobile } from '@/utils'
import { useEffect, useState, JSX } from 'react'
import { useTranslation } from 'react-i18next'
import ReactSignatureCanvas from 'react-signature-canvas'
import { Clear, Container, InfoSection } from './styles'

interface Messages {
  signPoa_here: string
  signPoa_hereMobile: string
}

const useMessages = (): Messages => {
  const { t } = useTranslation()

  return {
    signPoa_here: t('signPoa_here'),
    signPoa_hereMobile: t('signPoa_hereMobile'),
  }
}

export interface SignatureCanvasProps {
  onChange: (dataUrl?: string) => void
  value?: string
}

export const SignatureCanvas = ({
  onChange,
  value,
}: SignatureCanvasProps): JSX.Element => {
  const messages = useMessages()
  const [ref, setRef] = useState<ReactSignatureCanvas | null>(null)
  const [canvasValue, setCanvasValue] = useState<string | undefined>()
  const [isTouched, setIsTouched] = useState<boolean>(false)

  const { mobileDevice } = useIsMobile(Breakpoint.sm)

  useEffect(() => {
    if (canvasValue) {
      onChange(ref?.getTrimmedCanvas?.()?.toDataURL('image/png'))
    } else if (value) {
      onChange()
    }
  }, [canvasValue, onChange, ref, value])

  const handleClear = (): void => {
    if (ref) {
      ref.clear()
    }
    setCanvasValue(undefined)
    setIsTouched(false)
  }

  return (
    <Container isTouched={isTouched || !!canvasValue}>
      <ReactSignatureCanvas
        ref={(signatureCanvas) => setRef(signatureCanvas)}
        clearOnResize={false}
        onBegin={() => setIsTouched(true)}
        onEnd={() => {
          setCanvasValue(ref?.toDataURL('image/png'))
        }}
      />
      {canvasValue ? (
        <Clear onClick={handleClear}>
          <ClearIcon fill="none" />
        </Clear>
      ) : (
        <InfoSection>
          {mobileDevice ? messages.signPoa_hereMobile : messages.signPoa_here}
        </InfoSection>
      )}
    </Container>
  )
}
